// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "assets/css/" + {"489":"body","535":"login"}[chunkId] + "." + {"489":"e903d033","535":"6641feb0"}[chunkId] + ".css";
};